import { convertDayPipe } from './convert-day.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

const PipeComponent = [ 
    convertDayPipe
];

@NgModule({
    declarations: [PipeComponent],
    imports: [CommonModule],
    exports: [PipeComponent]
})
export class PipeModule {}
